module.exports = __webpack_public_path__ + "media/images/thumbs/physanims/a6-1-65a58378b987062f1486aed6151eb074.jpg";